import React from 'react';
import LandingPage from './pages/LandingPage';
import WidgetPage from './pages/WidgetPage';
import AdminDashboard from './admin/pages/AdminDashboard';
import DocsPage from './pages/DocsPage';
import LegalPage from './pages/LegalPage';
import VerifyPage from './pages/VerifyPage';
import ChatBot from './components/ChatBot';

function App() {
  const path = window.location.pathname;
  const hostname = window.location.hostname;

  // Subdomain routing (ready for when subdomains are configured)
  const subdomain = hostname.split('.')[0];
  const isSubdomain = hostname.includes('afrilink.io') && subdomain !== 'afrilink' && subdomain !== 'www';

  if (isSubdomain && subdomain === 'connect') return <><WidgetPage /><ChatBot /></>;
  if (isSubdomain && subdomain === 'dashboard') return <><AdminDashboard /><ChatBot /></>;
  if (isSubdomain && subdomain === 'docs') return <><DocsPage /><ChatBot /></>;
  if (isSubdomain && subdomain === 'verify') return <><VerifyPage /><ChatBot /></>;

  // Standard path routing
  return (
    <>
      {path === '/admin' && <AdminDashboard />}
      {path === '/docs' && <DocsPage />}
      {path === '/widget' && <WidgetPage />}
      {path === '/legal' && <LegalPage />}
      {path === '/verify' && <VerifyPage />}
      {path !== '/admin' && path !== '/docs' && path !== '/widget' && path !== '/legal' && path !== '/verify' && <LandingPage />}
      <ChatBot />
    </>
  );
}

export default App;
